export default {"src":"/_next/static/media/twitter.5f3a02be.svg","height":13,"width":15,"blurWidth":0,"blurHeight":0};